// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/split_supply_plan_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { PresignedHttpRequest } from "../../bfftypes/v1/presigned_http_request_pb";
import { file_bfftypes_v1_presigned_http_request } from "../../bfftypes/v1/presigned_http_request_pb";
import type { SplitSupplyBusiness } from "./split_supply_contract_model_pb";
import { file_bffuser_v1_split_supply_contract_model } from "./split_supply_contract_model_pb";
import type { SplitSupplyNoticeDetailPoint, SplitSupplyNoticeDownloadFormat, SplitSupplyNoticeKey, SplitSupplyNoticeListItem, SplitSupplyNoticeNotEditableReason, SplitSupplyNoticePointInput, SplitSupplyNoticeSection, SplitSupplyOwnNoticeBlankPoint, SplitSupplyOwnNoticeImportItem, SplitSupplyOwnNoticeSkipCount, SplitSupplyOwnNoticeSkippedPoint, SplitSupplyPartnerNoticeAreaOption, SplitSupplyPartnerNoticeChannel, SplitSupplyPartnerNoticeDetailPoint, SplitSupplyPartnerNoticeFillState, SplitSupplyPartnerNoticeImportError, SplitSupplyPartnerNoticeImportItem, SplitSupplyPartnerNoticeListItem, SplitSupplyPartnerNoticePointInput, SplitSupplyPartnerNoticeSkipCount, SplitSupplyPartnerNoticeSkippedPoint } from "./split_supply_plan_model_pb";
import { file_bffuser_v1_split_supply_plan_model } from "./split_supply_plan_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/split_supply_plan_service.proto.
 */
export const file_bffuser_v1_split_supply_plan_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_presigned_http_request, file_bffuser_v1_split_supply_contract_model, file_bffuser_v1_split_supply_plan_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * @generated from message bffuser.v1.ListOwnSplitSupplyNoticesRequest
 */
export type ListOwnSplitSupplyNoticesRequest = Message<"bffuser.v1.ListOwnSplitSupplyNoticesRequest"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 1;
   */
  section: SplitSupplyNoticeSection;

  /**
   * The delivery date of a 翌日 list, any day of the month of a 月間 list.
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * Narrow to one area. Absent = every area.
   *
   * @generated from field: optional bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode?: AreaCode;
};

/**
 * Describes the message bffuser.v1.ListOwnSplitSupplyNoticesRequest.
 * Use `create(ListOwnSplitSupplyNoticesRequestSchema)` to create a new message.
 */
export const ListOwnSplitSupplyNoticesRequestSchema: GenMessage<ListOwnSplitSupplyNoticesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 0);

/**
 * @generated from message bffuser.v1.ListOwnSplitSupplyNoticesResponse
 */
export type ListOwnSplitSupplyNoticesResponse = Message<"bffuser.v1.ListOwnSplitSupplyNoticesResponse"> & {
  /**
   * Ordered by area, own business code, 負荷追随分供給者 code, contract
   * identifier 1.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyNoticeListItem items = 1;
   */
  items: SplitSupplyNoticeListItem[];
};

/**
 * Describes the message bffuser.v1.ListOwnSplitSupplyNoticesResponse.
 * Use `create(ListOwnSplitSupplyNoticesResponseSchema)` to create a new message.
 */
export const ListOwnSplitSupplyNoticesResponseSchema: GenMessage<ListOwnSplitSupplyNoticesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 1);

/**
 * @generated from message bffuser.v1.CreateOwnSplitSupplyNoticesRequest
 */
export type CreateOwnSplitSupplyNoticesRequest = Message<"bffuser.v1.CreateOwnSplitSupplyNoticesRequest"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 1;
   */
  section: SplitSupplyNoticeSection;

  /**
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;
};

/**
 * Describes the message bffuser.v1.CreateOwnSplitSupplyNoticesRequest.
 * Use `create(CreateOwnSplitSupplyNoticesRequestSchema)` to create a new message.
 */
export const CreateOwnSplitSupplyNoticesRequestSchema: GenMessage<CreateOwnSplitSupplyNoticesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 2);

/**
 * @generated from message bffuser.v1.CreateOwnSplitSupplyNoticesResponse
 */
export type CreateOwnSplitSupplyNoticesResponse = Message<"bffuser.v1.CreateOwnSplitSupplyNoticesResponse"> & {
  /**
   * Supply points whose 通告値 were created now.
   *
   * @generated from field: int32 created_count = 1;
   */
  createdCount: number;

  /**
   * Supply points that already had one.
   *
   * @generated from field: int32 existing_count = 2;
   */
  existingCount: number;
};

/**
 * Describes the message bffuser.v1.CreateOwnSplitSupplyNoticesResponse.
 * Use `create(CreateOwnSplitSupplyNoticesResponseSchema)` to create a new message.
 */
export const CreateOwnSplitSupplyNoticesResponseSchema: GenMessage<CreateOwnSplitSupplyNoticesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 3);

/**
 * @generated from message bffuser.v1.GetOwnSplitSupplyNoticeRequest
 */
export type GetOwnSplitSupplyNoticeRequest = Message<"bffuser.v1.GetOwnSplitSupplyNoticeRequest"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeKey key = 1;
   */
  key?: SplitSupplyNoticeKey;

  /**
   * The delivery date to show: the target date of a 翌日 通, a day of the month
   * of a 月間 通 (NOTICE_DELIVERY_DATE_OUT_OF_PERIOD otherwise). Absent = every
   * day of the period (a 月間 通 returns the whole month).
   *
   * @generated from field: optional google.type.Date delivery_date = 2;
   */
  deliveryDate?: Date;
};

/**
 * Describes the message bffuser.v1.GetOwnSplitSupplyNoticeRequest.
 * Use `create(GetOwnSplitSupplyNoticeRequestSchema)` to create a new message.
 */
export const GetOwnSplitSupplyNoticeRequestSchema: GenMessage<GetOwnSplitSupplyNoticeRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 4);

/**
 * @generated from message bffuser.v1.GetOwnSplitSupplyNoticeResponse
 */
export type GetOwnSplitSupplyNoticeResponse = Message<"bffuser.v1.GetOwnSplitSupplyNoticeResponse"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeKey key = 1;
   */
  key?: SplitSupplyNoticeKey;

  /**
   * @generated from field: bffuser.v1.SplitSupplyBusiness own_business = 2;
   */
  ownBusiness?: SplitSupplyBusiness;

  /**
   * @generated from field: bffuser.v1.SplitSupplyBusiness load_following = 3;
   */
  loadFollowing?: SplitSupplyBusiness;

  /**
   * @generated from field: repeated bffuser.v1.SplitSupplyNoticeDetailPoint points = 4;
   */
  points: SplitSupplyNoticeDetailPoint[];

  /**
   * Whether the 通 can be edited today (JST).
   *
   * @generated from field: bool editable = 5;
   */
  editable: boolean;

  /**
   * Set when editable is false.
   *
   * @generated from field: bffuser.v1.SplitSupplyNoticeNotEditableReason not_editable_reason = 6;
   */
  notEditableReason: SplitSupplyNoticeNotEditableReason;

  /**
   * The earliest creation and the latest update among the supply points (the
   * same rule as the list's).
   *
   * @generated from field: optional string created_by = 7;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 9;
   */
  updatedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * The 受電側送配電 the 通 is submitted to (提出先): its code and name.
   *
   * @generated from field: string recipient_code = 11;
   */
  recipientCode: string;

  /**
   * @generated from field: string recipient_name = 12;
   */
  recipientName: string;

  /**
   * The largest number of supply points one OCCTO message (one XML file) may
   * hold; a 通 with more is split into several files.
   *
   * @generated from field: int32 max_point_count = 13;
   */
  maxPointCount: number;
};

/**
 * Describes the message bffuser.v1.GetOwnSplitSupplyNoticeResponse.
 * Use `create(GetOwnSplitSupplyNoticeResponseSchema)` to create a new message.
 */
export const GetOwnSplitSupplyNoticeResponseSchema: GenMessage<GetOwnSplitSupplyNoticeResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 5);

/**
 * @generated from message bffuser.v1.SaveOwnSplitSupplyNoticeValuesRequest
 */
export type SaveOwnSplitSupplyNoticeValuesRequest = Message<"bffuser.v1.SaveOwnSplitSupplyNoticeValuesRequest"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeKey key = 1;
   */
  key?: SplitSupplyNoticeKey;

  /**
   * Every supply point of the 通, each with the delivery dates saved (one day,
   * or a whole month; 1000 points × 31 days is the largest request).
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyNoticePointInput points = 2;
   */
  points: SplitSupplyNoticePointInput[];
};

/**
 * Describes the message bffuser.v1.SaveOwnSplitSupplyNoticeValuesRequest.
 * Use `create(SaveOwnSplitSupplyNoticeValuesRequestSchema)` to create a new message.
 */
export const SaveOwnSplitSupplyNoticeValuesRequestSchema: GenMessage<SaveOwnSplitSupplyNoticeValuesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 6);

/**
 * SaveOwnSplitSupplyNoticeValuesResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.SaveOwnSplitSupplyNoticeValuesResponse
 */
export type SaveOwnSplitSupplyNoticeValuesResponse = Message<"bffuser.v1.SaveOwnSplitSupplyNoticeValuesResponse"> & {
};

/**
 * Describes the message bffuser.v1.SaveOwnSplitSupplyNoticeValuesResponse.
 * Use `create(SaveOwnSplitSupplyNoticeValuesResponseSchema)` to create a new message.
 */
export const SaveOwnSplitSupplyNoticeValuesResponseSchema: GenMessage<SaveOwnSplitSupplyNoticeValuesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 7);

/**
 * @generated from message bffuser.v1.DownloadOwnSplitSupplyNoticeXmlRequest
 */
export type DownloadOwnSplitSupplyNoticeXmlRequest = Message<"bffuser.v1.DownloadOwnSplitSupplyNoticeXmlRequest"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeKey key = 1;
   */
  key?: SplitSupplyNoticeKey;

  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeDownloadFormat format = 2;
   */
  format: SplitSupplyNoticeDownloadFormat;
};

/**
 * Describes the message bffuser.v1.DownloadOwnSplitSupplyNoticeXmlRequest.
 * Use `create(DownloadOwnSplitSupplyNoticeXmlRequestSchema)` to create a new message.
 */
export const DownloadOwnSplitSupplyNoticeXmlRequestSchema: GenMessage<DownloadOwnSplitSupplyNoticeXmlRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 8);

/**
 * @generated from message bffuser.v1.DownloadOwnSplitSupplyNoticeXmlResponse
 */
export type DownloadOwnSplitSupplyNoticeXmlResponse = Message<"bffuser.v1.DownloadOwnSplitSupplyNoticeXmlResponse"> & {
  /**
   * Raw bytes: the XML, or a ZIP of the XML file(s).
   *
   * @generated from field: bytes content = 1;
   */
  content: Uint8Array;

  /**
   * OCCTO file name (W6_<情報区分>_<対象日>_<通告値分割番号 4 桁>_<送信者 5 桁>_<エリア 1 桁>.xml;
   * ".zip" for a ZIP).
   *
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * MIME type ("application/xml", "application/zip").
   *
   * @generated from field: string content_type = 3;
   */
  contentType: string;
};

/**
 * Describes the message bffuser.v1.DownloadOwnSplitSupplyNoticeXmlResponse.
 * Use `create(DownloadOwnSplitSupplyNoticeXmlResponseSchema)` to create a new message.
 */
export const DownloadOwnSplitSupplyNoticeXmlResponseSchema: GenMessage<DownloadOwnSplitSupplyNoticeXmlResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 9);

/**
 * @generated from message bffuser.v1.ListPartnerSplitSupplyNoticesRequest
 */
export type ListPartnerSplitSupplyNoticesRequest = Message<"bffuser.v1.ListPartnerSplitSupplyNoticesRequest"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 1;
   */
  section: SplitSupplyNoticeSection;

  /**
   * The delivery date of a 翌日 list, any day of the month of a 月間 list.
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * Narrow to one area. Absent = every area.
   *
   * @generated from field: optional bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode?: AreaCode;
};

/**
 * Describes the message bffuser.v1.ListPartnerSplitSupplyNoticesRequest.
 * Use `create(ListPartnerSplitSupplyNoticesRequestSchema)` to create a new message.
 */
export const ListPartnerSplitSupplyNoticesRequestSchema: GenMessage<ListPartnerSplitSupplyNoticesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 10);

/**
 * @generated from message bffuser.v1.ListPartnerSplitSupplyNoticesResponse
 */
export type ListPartnerSplitSupplyNoticesResponse = Message<"bffuser.v1.ListPartnerSplitSupplyNoticesResponse"> & {
  /**
   * The latest 登録日時 first.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyPartnerNoticeListItem items = 1;
   */
  items: SplitSupplyPartnerNoticeListItem[];
};

/**
 * Describes the message bffuser.v1.ListPartnerSplitSupplyNoticesResponse.
 * Use `create(ListPartnerSplitSupplyNoticesResponseSchema)` to create a new message.
 */
export const ListPartnerSplitSupplyNoticesResponseSchema: GenMessage<ListPartnerSplitSupplyNoticesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 11);

/**
 * @generated from message bffuser.v1.GetPartnerSplitSupplyNoticeFormOptionsRequest
 */
export type GetPartnerSplitSupplyNoticeFormOptionsRequest = Message<"bffuser.v1.GetPartnerSplitSupplyNoticeFormOptionsRequest"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 1;
   */
  section: SplitSupplyNoticeSection;

  /**
   * The delivery date of a 翌日 registration, any day of the month of a 月間 one.
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;
};

/**
 * Describes the message bffuser.v1.GetPartnerSplitSupplyNoticeFormOptionsRequest.
 * Use `create(GetPartnerSplitSupplyNoticeFormOptionsRequestSchema)` to create a new message.
 */
export const GetPartnerSplitSupplyNoticeFormOptionsRequestSchema: GenMessage<GetPartnerSplitSupplyNoticeFormOptionsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 12);

/**
 * @generated from message bffuser.v1.GetPartnerSplitSupplyNoticeFormOptionsResponse
 */
export type GetPartnerSplitSupplyNoticeFormOptionsResponse = Message<"bffuser.v1.GetPartnerSplitSupplyNoticeFormOptionsResponse"> & {
  /**
   * Only the areas that have a company to register for, ordered by area.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyPartnerNoticeAreaOption areas = 1;
   */
  areas: SplitSupplyPartnerNoticeAreaOption[];
};

/**
 * Describes the message bffuser.v1.GetPartnerSplitSupplyNoticeFormOptionsResponse.
 * Use `create(GetPartnerSplitSupplyNoticeFormOptionsResponseSchema)` to create a new message.
 */
export const GetPartnerSplitSupplyNoticeFormOptionsResponseSchema: GenMessage<GetPartnerSplitSupplyNoticeFormOptionsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 13);

/**
 * @generated from message bffuser.v1.CreatePartnerSplitSupplyNoticeRequest
 */
export type CreatePartnerSplitSupplyNoticeRequest = Message<"bffuser.v1.CreatePartnerSplitSupplyNoticeRequest"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 1;
   */
  section: SplitSupplyNoticeSection;

  /**
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * UUID of the business master of the company that gave the values.
   *
   * @generated from field: string partner_business_master_id = 4;
   */
  partnerBusinessMasterId: string;
};

/**
 * Describes the message bffuser.v1.CreatePartnerSplitSupplyNoticeRequest.
 * Use `create(CreatePartnerSplitSupplyNoticeRequestSchema)` to create a new message.
 */
export const CreatePartnerSplitSupplyNoticeRequestSchema: GenMessage<CreatePartnerSplitSupplyNoticeRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 14);

/**
 * @generated from message bffuser.v1.CreatePartnerSplitSupplyNoticeResponse
 */
export type CreatePartnerSplitSupplyNoticeResponse = Message<"bffuser.v1.CreatePartnerSplitSupplyNoticeResponse"> & {
  /**
   * The id of the registration: the new one, or the one that already exists for
   * the same 断面 x 対象日 x エリア x 他社 (nothing is created then).
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Whether a registration was created. false = the registration already existed
   * and is unchanged.
   *
   * @generated from field: bool created = 2;
   */
  created: boolean;
};

/**
 * Describes the message bffuser.v1.CreatePartnerSplitSupplyNoticeResponse.
 * Use `create(CreatePartnerSplitSupplyNoticeResponseSchema)` to create a new message.
 */
export const CreatePartnerSplitSupplyNoticeResponseSchema: GenMessage<CreatePartnerSplitSupplyNoticeResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 15);

/**
 * @generated from message bffuser.v1.GetPartnerSplitSupplyNoticeRequest
 */
export type GetPartnerSplitSupplyNoticeRequest = Message<"bffuser.v1.GetPartnerSplitSupplyNoticeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The delivery date to show (NOTICE_DELIVERY_DATE_OUT_OF_PERIOD when it is
   * outside the period). Absent = every day of the period.
   *
   * @generated from field: optional google.type.Date delivery_date = 2;
   */
  deliveryDate?: Date;
};

/**
 * Describes the message bffuser.v1.GetPartnerSplitSupplyNoticeRequest.
 * Use `create(GetPartnerSplitSupplyNoticeRequestSchema)` to create a new message.
 */
export const GetPartnerSplitSupplyNoticeRequestSchema: GenMessage<GetPartnerSplitSupplyNoticeRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 16);

/**
 * @generated from message bffuser.v1.GetPartnerSplitSupplyNoticeResponse
 */
export type GetPartnerSplitSupplyNoticeResponse = Message<"bffuser.v1.GetPartnerSplitSupplyNoticeResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 2;
   */
  section: SplitSupplyNoticeSection;

  /**
   * @generated from field: google.type.Date target_date = 3;
   */
  targetDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: string counterparty_business_code = 5;
   */
  counterpartyBusinessCode: string;

  /**
   * @generated from field: string counterparty_business_name = 6;
   */
  counterpartyBusinessName: string;

  /**
   * @generated from field: bffuser.v1.SplitSupplyPartnerNoticeChannel channel = 7;
   */
  channel: SplitSupplyPartnerNoticeChannel;

  /**
   * @generated from field: string source_file_name = 8;
   */
  sourceFileName: string;

  /**
   * @generated from field: repeated bffuser.v1.SplitSupplyPartnerNoticeDetailPoint points = 9;
   */
  points: SplitSupplyPartnerNoticeDetailPoint[];

  /**
   * The registration (登録日時・登録者).
   *
   * @generated from field: optional string created_by = 10;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp;

  /**
   * The last update (最終更新) and the optimistic-lock baseline of a save. Equal to
   * the registration until the first save.
   *
   * @generated from field: optional string updated_by = 12;
   */
  updatedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */
  updatedAt?: Timestamp;

  /**
   * Whether the registration can be deleted today (JST): its date is tomorrow or
   * later (a 翌日 registration delivered tomorrow or later, a 月間 one of next
   * month or later: the same line as the 自社の通告値's editable), or it is empty.
   * Editing and saving stay possible for a past registration.
   *
   * @generated from field: bool deletable = 14;
   */
  deletable: boolean;

  /**
   * Whether no value has ever been saved (no supply point holds a value row). An
   * empty registration can be deleted whatever its date is.
   *
   * @generated from field: bool empty = 15;
   */
  empty: boolean;

  /**
   * Whether the registration is past by date alone: delivered today or earlier
   * (a 月間 one: this month or earlier). Independent of whether it is empty.
   *
   * @generated from field: bool past = 16;
   */
  past: boolean;

  /**
   * How far the values of the whole period are entered (shown as the status).
   *
   * @generated from field: bffuser.v1.SplitSupplyPartnerNoticeFillState fill_state = 17;
   */
  fillState: SplitSupplyPartnerNoticeFillState;
};

/**
 * Describes the message bffuser.v1.GetPartnerSplitSupplyNoticeResponse.
 * Use `create(GetPartnerSplitSupplyNoticeResponseSchema)` to create a new message.
 */
export const GetPartnerSplitSupplyNoticeResponseSchema: GenMessage<GetPartnerSplitSupplyNoticeResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 17);

/**
 * @generated from message bffuser.v1.SavePartnerSplitSupplyNoticeValuesRequest
 */
export type SavePartnerSplitSupplyNoticeValuesRequest = Message<"bffuser.v1.SavePartnerSplitSupplyNoticeValuesRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Every supply point of the registration, each with the delivery dates saved
   * (one day, or a whole month; 1000 points x 31 days is the largest request).
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyPartnerNoticePointInput points = 2;
   */
  points: SplitSupplyPartnerNoticePointInput[];

  /**
   * The updated_at the caller read.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 3;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.SavePartnerSplitSupplyNoticeValuesRequest.
 * Use `create(SavePartnerSplitSupplyNoticeValuesRequestSchema)` to create a new message.
 */
export const SavePartnerSplitSupplyNoticeValuesRequestSchema: GenMessage<SavePartnerSplitSupplyNoticeValuesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 18);

/**
 * SavePartnerSplitSupplyNoticeValuesResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.SavePartnerSplitSupplyNoticeValuesResponse
 */
export type SavePartnerSplitSupplyNoticeValuesResponse = Message<"bffuser.v1.SavePartnerSplitSupplyNoticeValuesResponse"> & {
};

/**
 * Describes the message bffuser.v1.SavePartnerSplitSupplyNoticeValuesResponse.
 * Use `create(SavePartnerSplitSupplyNoticeValuesResponseSchema)` to create a new message.
 */
export const SavePartnerSplitSupplyNoticeValuesResponseSchema: GenMessage<SavePartnerSplitSupplyNoticeValuesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 19);

/**
 * @generated from message bffuser.v1.DeletePartnerSplitSupplyNoticeRequest
 */
export type DeletePartnerSplitSupplyNoticeRequest = Message<"bffuser.v1.DeletePartnerSplitSupplyNoticeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The updated_at the caller read.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeletePartnerSplitSupplyNoticeRequest.
 * Use `create(DeletePartnerSplitSupplyNoticeRequestSchema)` to create a new message.
 */
export const DeletePartnerSplitSupplyNoticeRequestSchema: GenMessage<DeletePartnerSplitSupplyNoticeRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 20);

/**
 * DeletePartnerSplitSupplyNoticeResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeletePartnerSplitSupplyNoticeResponse
 */
export type DeletePartnerSplitSupplyNoticeResponse = Message<"bffuser.v1.DeletePartnerSplitSupplyNoticeResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeletePartnerSplitSupplyNoticeResponse.
 * Use `create(DeletePartnerSplitSupplyNoticeResponseSchema)` to create a new message.
 */
export const DeletePartnerSplitSupplyNoticeResponseSchema: GenMessage<DeletePartnerSplitSupplyNoticeResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 21);

/**
 * @generated from message bffuser.v1.IssuePartnerSplitSupplyNoticeUploadUrlRequest
 */
export type IssuePartnerSplitSupplyNoticeUploadUrlRequest = Message<"bffuser.v1.IssuePartnerSplitSupplyNoticeUploadUrlRequest"> & {
  /**
   * The name of the file as the user has it, recorded with the registration
   * (the directory part is dropped; at most 250 characters are kept).
   *
   * @generated from field: string file_name = 1;
   */
  fileName: string;
};

/**
 * Describes the message bffuser.v1.IssuePartnerSplitSupplyNoticeUploadUrlRequest.
 * Use `create(IssuePartnerSplitSupplyNoticeUploadUrlRequestSchema)` to create a new message.
 */
export const IssuePartnerSplitSupplyNoticeUploadUrlRequestSchema: GenMessage<IssuePartnerSplitSupplyNoticeUploadUrlRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 22);

/**
 * @generated from message bffuser.v1.IssuePartnerSplitSupplyNoticeUploadUrlResponse
 */
export type IssuePartnerSplitSupplyNoticeUploadUrlResponse = Message<"bffuser.v1.IssuePartnerSplitSupplyNoticeUploadUrlResponse"> & {
  /**
   * One-time token to pass in upload_tokens.
   *
   * @generated from field: string upload_token = 1;
   */
  uploadToken: string;

  /**
   * Presigned PUT request the browser sends the file to.
   *
   * @generated from field: bfftypes.v1.PresignedHttpRequest upload = 2;
   */
  upload?: PresignedHttpRequest;

  /**
   * Upper bound on the file size in bytes. The signed headers in upload enforce
   * it at the object store; the caller can check it before sending.
   *
   * @generated from field: int64 max_content_bytes = 3;
   */
  maxContentBytes: bigint;
};

/**
 * Describes the message bffuser.v1.IssuePartnerSplitSupplyNoticeUploadUrlResponse.
 * Use `create(IssuePartnerSplitSupplyNoticeUploadUrlResponseSchema)` to create a new message.
 */
export const IssuePartnerSplitSupplyNoticeUploadUrlResponseSchema: GenMessage<IssuePartnerSplitSupplyNoticeUploadUrlResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 23);

/**
 * @generated from message bffuser.v1.PreviewPartnerSplitSupplyNoticeImportRequest
 */
export type PreviewPartnerSplitSupplyNoticeImportRequest = Message<"bffuser.v1.PreviewPartnerSplitSupplyNoticeImportRequest"> & {
  /**
   * The uploaded files, 1 to 20, each token once.
   *
   * @generated from field: repeated string upload_tokens = 1;
   */
  uploadTokens: string[];

  /**
   * The tab the files are for.
   *
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 2;
   */
  section: SplitSupplyNoticeSection;
};

/**
 * Describes the message bffuser.v1.PreviewPartnerSplitSupplyNoticeImportRequest.
 * Use `create(PreviewPartnerSplitSupplyNoticeImportRequestSchema)` to create a new message.
 */
export const PreviewPartnerSplitSupplyNoticeImportRequestSchema: GenMessage<PreviewPartnerSplitSupplyNoticeImportRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 24);

/**
 * @generated from message bffuser.v1.PreviewPartnerSplitSupplyNoticeImportResponse
 */
export type PreviewPartnerSplitSupplyNoticeImportResponse = Message<"bffuser.v1.PreviewPartnerSplitSupplyNoticeImportResponse"> & {
  /**
   * The 通 the import would register, ordered by 断面, 対象日, エリア, 他社コード.
   * Empty when the files have errors.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyPartnerNoticeImportItem notices = 1;
   */
  notices: SplitSupplyPartnerNoticeImportItem[];

  /**
   * The supply points left out; the first 100.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyPartnerNoticeSkippedPoint skipped_points = 2;
   */
  skippedPoints: SplitSupplyPartnerNoticeSkippedPoint[];

  /**
   * @generated from field: int32 skipped_point_count = 3;
   */
  skippedPointCount: number;

  /**
   * How many supply points were left out for each reason.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyPartnerNoticeSkipCount skipped_counts = 4;
   */
  skippedCounts: SplitSupplyPartnerNoticeSkipCount[];

  /**
   * Files in ZIPs that are neither XML nor CSV and were ignored.
   *
   * @generated from field: int32 ignored_file_count = 5;
   */
  ignoredFileCount: number;

  /**
   * The errors of the files; the first 100. While there are errors nothing can
   * be imported.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyPartnerNoticeImportError errors = 6;
   */
  errors: SplitSupplyPartnerNoticeImportError[];

  /**
   * @generated from field: int32 error_count = 7;
   */
  errorCount: number;

  /**
   * Digest of the whole plan, passed to ImportPartnerSplitSupplyNotices.
   *
   * @generated from field: string digest = 8;
   */
  digest: string;

  /**
   * No supply point of the files can be imported.
   *
   * @generated from field: bool nothing = 9;
   */
  nothing: boolean;

  /**
   * The files exceed a limit (the number of files, the size of a file or of all
   * of them once inflated, a ZIP compressing too far).
   *
   * @generated from field: bool too_large = 10;
   */
  tooLarge: boolean;
};

/**
 * Describes the message bffuser.v1.PreviewPartnerSplitSupplyNoticeImportResponse.
 * Use `create(PreviewPartnerSplitSupplyNoticeImportResponseSchema)` to create a new message.
 */
export const PreviewPartnerSplitSupplyNoticeImportResponseSchema: GenMessage<PreviewPartnerSplitSupplyNoticeImportResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 25);

/**
 * @generated from message bffuser.v1.ImportPartnerSplitSupplyNoticesRequest
 */
export type ImportPartnerSplitSupplyNoticesRequest = Message<"bffuser.v1.ImportPartnerSplitSupplyNoticesRequest"> & {
  /**
   * @generated from field: repeated string upload_tokens = 1;
   */
  uploadTokens: string[];

  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 2;
   */
  section: SplitSupplyNoticeSection;

  /**
   * The digest the preview of the same files returned.
   *
   * @generated from field: string digest = 3;
   */
  digest: string;
};

/**
 * Describes the message bffuser.v1.ImportPartnerSplitSupplyNoticesRequest.
 * Use `create(ImportPartnerSplitSupplyNoticesRequestSchema)` to create a new message.
 */
export const ImportPartnerSplitSupplyNoticesRequestSchema: GenMessage<ImportPartnerSplitSupplyNoticesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 26);

/**
 * @generated from message bffuser.v1.ImportPartnerSplitSupplyNoticesResponse
 */
export type ImportPartnerSplitSupplyNoticesResponse = Message<"bffuser.v1.ImportPartnerSplitSupplyNoticesResponse"> & {
  /**
   * 通 registered for the first time.
   *
   * @generated from field: int32 created_count = 1;
   */
  createdCount: number;

  /**
   * 通 that replaced a registration.
   *
   * @generated from field: int32 replaced_count = 2;
   */
  replacedCount: number;

  /**
   * The supply points registered, each counted once whatever the number of 通 it is in.
   *
   * @generated from field: int32 registered_point_count = 3;
   */
  registeredPointCount: number;

  /**
   * How the files were registered: XML or CSV.
   *
   * @generated from field: bffuser.v1.SplitSupplyPartnerNoticeChannel channel = 4;
   */
  channel: SplitSupplyPartnerNoticeChannel;

  /**
   * The supply points left out of the registrations (the rows of the dialog that
   * lists them): the whole count, and the first 100 of them.
   *
   * @generated from field: int32 skipped_point_count = 5;
   */
  skippedPointCount: number;

  /**
   * @generated from field: repeated bffuser.v1.SplitSupplyPartnerNoticeSkippedPoint skipped_points = 6;
   */
  skippedPoints: SplitSupplyPartnerNoticeSkippedPoint[];
};

/**
 * Describes the message bffuser.v1.ImportPartnerSplitSupplyNoticesResponse.
 * Use `create(ImportPartnerSplitSupplyNoticesResponseSchema)` to create a new message.
 */
export const ImportPartnerSplitSupplyNoticesResponseSchema: GenMessage<ImportPartnerSplitSupplyNoticesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 27);

/**
 * @generated from message bffuser.v1.IssueOwnSplitSupplyNoticeUploadUrlRequest
 */
export type IssueOwnSplitSupplyNoticeUploadUrlRequest = Message<"bffuser.v1.IssueOwnSplitSupplyNoticeUploadUrlRequest"> & {
  /**
   * The name of the file as the user has it (the directory part is dropped; at
   * most 250 characters are kept).
   *
   * @generated from field: string file_name = 1;
   */
  fileName: string;
};

/**
 * Describes the message bffuser.v1.IssueOwnSplitSupplyNoticeUploadUrlRequest.
 * Use `create(IssueOwnSplitSupplyNoticeUploadUrlRequestSchema)` to create a new message.
 */
export const IssueOwnSplitSupplyNoticeUploadUrlRequestSchema: GenMessage<IssueOwnSplitSupplyNoticeUploadUrlRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 28);

/**
 * @generated from message bffuser.v1.IssueOwnSplitSupplyNoticeUploadUrlResponse
 */
export type IssueOwnSplitSupplyNoticeUploadUrlResponse = Message<"bffuser.v1.IssueOwnSplitSupplyNoticeUploadUrlResponse"> & {
  /**
   * One-time token to pass in upload_tokens.
   *
   * @generated from field: string upload_token = 1;
   */
  uploadToken: string;

  /**
   * Presigned PUT request the browser sends the file to.
   *
   * @generated from field: bfftypes.v1.PresignedHttpRequest upload = 2;
   */
  upload?: PresignedHttpRequest;

  /**
   * Upper bound on the file size in bytes (enforced by the signed headers).
   *
   * @generated from field: int64 max_content_bytes = 3;
   */
  maxContentBytes: bigint;
};

/**
 * Describes the message bffuser.v1.IssueOwnSplitSupplyNoticeUploadUrlResponse.
 * Use `create(IssueOwnSplitSupplyNoticeUploadUrlResponseSchema)` to create a new message.
 */
export const IssueOwnSplitSupplyNoticeUploadUrlResponseSchema: GenMessage<IssueOwnSplitSupplyNoticeUploadUrlResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 29);

/**
 * @generated from message bffuser.v1.PreviewOwnSplitSupplyNoticeImportRequest
 */
export type PreviewOwnSplitSupplyNoticeImportRequest = Message<"bffuser.v1.PreviewOwnSplitSupplyNoticeImportRequest"> & {
  /**
   * The uploaded files, 1 to 20, each token once.
   *
   * @generated from field: repeated string upload_tokens = 1;
   */
  uploadTokens: string[];

  /**
   * The tab the files are for.
   *
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 2;
   */
  section: SplitSupplyNoticeSection;
};

/**
 * Describes the message bffuser.v1.PreviewOwnSplitSupplyNoticeImportRequest.
 * Use `create(PreviewOwnSplitSupplyNoticeImportRequestSchema)` to create a new message.
 */
export const PreviewOwnSplitSupplyNoticeImportRequestSchema: GenMessage<PreviewOwnSplitSupplyNoticeImportRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 30);

/**
 * @generated from message bffuser.v1.PreviewOwnSplitSupplyNoticeImportResponse
 */
export type PreviewOwnSplitSupplyNoticeImportResponse = Message<"bffuser.v1.PreviewOwnSplitSupplyNoticeImportResponse"> & {
  /**
   * The 通 the import would write, ordered by 断面, 対象日, エリア, 自社の事業者,
   * 負荷追随分供給者, 契約識別番号 1. Empty when the files have errors.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyOwnNoticeImportItem notices = 1;
   */
  notices: SplitSupplyOwnNoticeImportItem[];

  /**
   * The supply points left out; the first 100.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyOwnNoticeSkippedPoint skipped_points = 2;
   */
  skippedPoints: SplitSupplyOwnNoticeSkippedPoint[];

  /**
   * @generated from field: int32 skipped_point_count = 3;
   */
  skippedPointCount: number;

  /**
   * How many supply points were left out for each reason.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyOwnNoticeSkipCount skipped_counts = 4;
   */
  skippedCounts: SplitSupplyOwnNoticeSkipCount[];

  /**
   * Files in ZIPs that are neither XML nor CSV and were ignored.
   *
   * @generated from field: int32 ignored_file_count = 5;
   */
  ignoredFileCount: number;

  /**
   * The errors of the files (shared with the other company's import); the first
   * 100. While there are errors nothing can be imported.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyPartnerNoticeImportError errors = 6;
   */
  errors: SplitSupplyPartnerNoticeImportError[];

  /**
   * @generated from field: int32 error_count = 7;
   */
  errorCount: number;

  /**
   * Digest of the whole plan, passed to ImportOwnSplitSupplyNotices.
   *
   * @generated from field: string digest = 8;
   */
  digest: string;

  /**
   * No supply point of the files can be imported.
   *
   * @generated from field: bool nothing = 9;
   */
  nothing: boolean;

  /**
   * The files exceed a limit.
   *
   * @generated from field: bool too_large = 10;
   */
  tooLarge: boolean;

  /**
   * Supply points with every slot of every day empty (not imported, not
   * touched): the count and the first 100.
   *
   * @generated from field: int32 blank_point_count = 11;
   */
  blankPointCount: number;

  /**
   * @generated from field: repeated bffuser.v1.SplitSupplyOwnNoticeBlankPoint blank_points = 12;
   */
  blankPoints: SplitSupplyOwnNoticeBlankPoint[];
};

/**
 * Describes the message bffuser.v1.PreviewOwnSplitSupplyNoticeImportResponse.
 * Use `create(PreviewOwnSplitSupplyNoticeImportResponseSchema)` to create a new message.
 */
export const PreviewOwnSplitSupplyNoticeImportResponseSchema: GenMessage<PreviewOwnSplitSupplyNoticeImportResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 31);

/**
 * @generated from message bffuser.v1.ImportOwnSplitSupplyNoticesRequest
 */
export type ImportOwnSplitSupplyNoticesRequest = Message<"bffuser.v1.ImportOwnSplitSupplyNoticesRequest"> & {
  /**
   * @generated from field: repeated string upload_tokens = 1;
   */
  uploadTokens: string[];

  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 2;
   */
  section: SplitSupplyNoticeSection;

  /**
   * The digest the preview of the same files returned.
   *
   * @generated from field: string digest = 3;
   */
  digest: string;
};

/**
 * Describes the message bffuser.v1.ImportOwnSplitSupplyNoticesRequest.
 * Use `create(ImportOwnSplitSupplyNoticesRequestSchema)` to create a new message.
 */
export const ImportOwnSplitSupplyNoticesRequestSchema: GenMessage<ImportOwnSplitSupplyNoticesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 32);

/**
 * @generated from message bffuser.v1.ImportOwnSplitSupplyNoticesResponse
 */
export type ImportOwnSplitSupplyNoticesResponse = Message<"bffuser.v1.ImportOwnSplitSupplyNoticesResponse"> & {
  /**
   * Supply points whose 通告値 was created.
   *
   * @generated from field: int32 created_point_count = 1;
   */
  createdPointCount: number;

  /**
   * Supply points whose 通告値 had days overwritten.
   *
   * @generated from field: int32 overwritten_point_count = 2;
   */
  overwrittenPointCount: number;

  /**
   * 通 the import touched.
   *
   * @generated from field: int32 notice_count = 3;
   */
  noticeCount: number;
};

/**
 * Describes the message bffuser.v1.ImportOwnSplitSupplyNoticesResponse.
 * Use `create(ImportOwnSplitSupplyNoticesResponseSchema)` to create a new message.
 */
export const ImportOwnSplitSupplyNoticesResponseSchema: GenMessage<ImportOwnSplitSupplyNoticesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 33);

/**
 * @generated from message bffuser.v1.DownloadOwnSplitSupplyNoticeCsvTemplateRequest
 */
export type DownloadOwnSplitSupplyNoticeCsvTemplateRequest = Message<"bffuser.v1.DownloadOwnSplitSupplyNoticeCsvTemplateRequest"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 1;
   */
  section: SplitSupplyNoticeSection;

  /**
   * The delivery date of a 翌日 template, a day of the month of a 月間 one.
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * Only the supply points of this area; all areas when absent.
   *
   * @generated from field: optional bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode?: AreaCode;
};

/**
 * Describes the message bffuser.v1.DownloadOwnSplitSupplyNoticeCsvTemplateRequest.
 * Use `create(DownloadOwnSplitSupplyNoticeCsvTemplateRequestSchema)` to create a new message.
 */
export const DownloadOwnSplitSupplyNoticeCsvTemplateRequestSchema: GenMessage<DownloadOwnSplitSupplyNoticeCsvTemplateRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 34);

/**
 * @generated from message bffuser.v1.DownloadOwnSplitSupplyNoticeCsvTemplateResponse
 */
export type DownloadOwnSplitSupplyNoticeCsvTemplateResponse = Message<"bffuser.v1.DownloadOwnSplitSupplyNoticeCsvTemplateResponse"> & {
  /**
   * The CSV (UTF-8 with a BOM), or a ZIP of such CSVs over 1000 supply points.
   *
   * @generated from field: bytes content = 1;
   */
  content: Uint8Array;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * MIME type ("text/csv", or "application/zip" for a ZIP).
   *
   * @generated from field: string content_type = 3;
   */
  contentType: string;
};

/**
 * Describes the message bffuser.v1.DownloadOwnSplitSupplyNoticeCsvTemplateResponse.
 * Use `create(DownloadOwnSplitSupplyNoticeCsvTemplateResponseSchema)` to create a new message.
 */
export const DownloadOwnSplitSupplyNoticeCsvTemplateResponseSchema: GenMessage<DownloadOwnSplitSupplyNoticeCsvTemplateResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 35);

/**
 * @generated from message bffuser.v1.GetSplitSupplyPlanAvailabilityRequest
 */
export type GetSplitSupplyPlanAvailabilityRequest = Message<"bffuser.v1.GetSplitSupplyPlanAvailabilityRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetSplitSupplyPlanAvailabilityRequest.
 * Use `create(GetSplitSupplyPlanAvailabilityRequestSchema)` to create a new message.
 */
export const GetSplitSupplyPlanAvailabilityRequestSchema: GenMessage<GetSplitSupplyPlanAvailabilityRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 36);

/**
 * @generated from message bffuser.v1.GetSplitSupplyPlanAvailabilityResponse
 */
export type GetSplitSupplyPlanAvailabilityResponse = Message<"bffuser.v1.GetSplitSupplyPlanAvailabilityResponse"> & {
  /**
   * @generated from field: bool feature_enabled = 1;
   */
  featureEnabled: boolean;
};

/**
 * Describes the message bffuser.v1.GetSplitSupplyPlanAvailabilityResponse.
 * Use `create(GetSplitSupplyPlanAvailabilityResponseSchema)` to create a new message.
 */
export const GetSplitSupplyPlanAvailabilityResponseSchema: GenMessage<GetSplitSupplyPlanAvailabilityResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_service, 37);

/**
 * SplitSupplyPlanService provides the 自社の通告値 of 分割供給 (the plan screen):
 * create, view, edit and download the 通告値 of the contracts whose 通告値 the
 * own side submits (docs/domain/models/split-supply.md). Submitting is not part
 * of this service yet.
 *
 * @generated from service bffuser.v1.SplitSupplyPlanService
 */
export const SplitSupplyPlanService: GenService<{
  /**
   * ListOwnSplitSupplyNotices returns the 通 of a 断面 and target date that were
   * created, optionally narrowed to one area.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.ListOwnSplitSupplyNotices
   */
  listOwnSplitSupplyNotices: {
    methodKind: "unary";
    input: typeof ListOwnSplitSupplyNoticesRequestSchema;
    output: typeof ListOwnSplitSupplyNoticesResponseSchema;
  },
  /**
   * CreateOwnSplitSupplyNotices creates the 通告値 of every supply point of the
   * area whose contract is a 変動型 with the own side as the 通告値を出す側. A
   * supply point that already has one is left as it is. Rejected with
   * NOTICE_DATE_CLOSED for a past 通, and with NOTICE_TOO_MANY_POINTS (nothing is
   * created) when a 通 would have more than 1000 supply points, the most a save
   * carries.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.CreateOwnSplitSupplyNotices
   */
  createOwnSplitSupplyNotices: {
    methodKind: "unary";
    input: typeof CreateOwnSplitSupplyNoticesRequestSchema;
    output: typeof CreateOwnSplitSupplyNoticesResponseSchema;
  },
  /**
   * GetOwnSplitSupplyNotice returns a 通 with the 48 slots of one delivery date
   * of every supply point, or of every day of the period when no delivery date
   * is asked. The slots are the stored values as they are.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.GetOwnSplitSupplyNotice
   */
  getOwnSplitSupplyNotice: {
    methodKind: "unary";
    input: typeof GetOwnSplitSupplyNoticeRequestSchema;
    output: typeof GetOwnSplitSupplyNoticeResponseSchema;
  },
  /**
   * SaveOwnSplitSupplyNoticeValues saves the 48 slots of the given delivery
   * dates (one day, or a whole month) of every supply point of the 通. Rejected with NOTICE_POINTS_CHANGED when the
   * supply points differ from the 通's, and Aborted when a record moved.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.SaveOwnSplitSupplyNoticeValues
   */
  saveOwnSplitSupplyNoticeValues: {
    methodKind: "unary";
    input: typeof SaveOwnSplitSupplyNoticeValuesRequestSchema;
    output: typeof SaveOwnSplitSupplyNoticeValuesResponseSchema;
  },
  /**
   * DownloadOwnSplitSupplyNoticeXml returns the OCCTO XML (0610 / 0620) of a 通,
   * as one XML or a ZIP of 100-point files. A 月間 通 carries every day of the
   * month. A past 通 can be downloaded.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.DownloadOwnSplitSupplyNoticeXml
   */
  downloadOwnSplitSupplyNoticeXml: {
    methodKind: "unary";
    input: typeof DownloadOwnSplitSupplyNoticeXmlRequestSchema;
    output: typeof DownloadOwnSplitSupplyNoticeXmlResponseSchema;
  },
  /**
   * ListPartnerSplitSupplyNotices returns the 他社の通告値 registrations of a
   * 断面 and target date, optionally narrowed to one area, the latest 登録日時
   * first. There is at most one registration per 断面 x 対象日 x エリア x 他社, and
   * only the asked 断面 and target date are read.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.ListPartnerSplitSupplyNotices
   */
  listPartnerSplitSupplyNotices: {
    methodKind: "unary";
    input: typeof ListPartnerSplitSupplyNoticesRequestSchema;
    output: typeof ListPartnerSplitSupplyNoticesResponseSchema;
  },
  /**
   * GetPartnerSplitSupplyNoticeFormOptions returns, per area, the companies a 他社の通告値
   * can be registered for on a target date: the other side of the 変動型
   * contracts whose 通告値 that company submits, judged on the date.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.GetPartnerSplitSupplyNoticeFormOptions
   */
  getPartnerSplitSupplyNoticeFormOptions: {
    methodKind: "unary";
    input: typeof GetPartnerSplitSupplyNoticeFormOptionsRequestSchema;
    output: typeof GetPartnerSplitSupplyNoticeFormOptionsResponseSchema;
  },
  /**
   * CreatePartnerSplitSupplyNotice registers an empty 他社の通告値 for every supply
   * point of the area whose contract is a 変動型 that the chosen company
   * submits the 通告値 of, judged on the delivery date (the first of the month for
   * 月間), and returns its id. Rejected with PARTNER_NOTICE_NO_POINTS (nothing is
   * created) when there is no such point. A past date is accepted. A registration
   * with no value is used for nothing.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.CreatePartnerSplitSupplyNotice
   */
  createPartnerSplitSupplyNotice: {
    methodKind: "unary";
    input: typeof CreatePartnerSplitSupplyNoticeRequestSchema;
    output: typeof CreatePartnerSplitSupplyNoticeResponseSchema;
  },
  /**
   * GetPartnerSplitSupplyNotice returns a registration with the 48 slots of one
   * delivery date of every supply point, or of every day of the period when no
   * delivery date is asked. Rejected with PARTNER_NOTICE_NOT_FOUND.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.GetPartnerSplitSupplyNotice
   */
  getPartnerSplitSupplyNotice: {
    methodKind: "unary";
    input: typeof GetPartnerSplitSupplyNoticeRequestSchema;
    output: typeof GetPartnerSplitSupplyNoticeResponseSchema;
  },
  /**
   * SavePartnerSplitSupplyNoticeValues replaces the 48 slots of the given
   * delivery dates of every supply point of the registration. The registration
   * (登録日時・登録者・登録方法) is unchanged and the last update is recorded. A past
   * registration can be saved. Rejected with PARTNER_NOTICE_POINTS_CHANGED when the supply
   * points differ, and Aborted when the registration moved since it was read.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.SavePartnerSplitSupplyNoticeValues
   */
  savePartnerSplitSupplyNoticeValues: {
    methodKind: "unary";
    input: typeof SavePartnerSplitSupplyNoticeValuesRequestSchema;
    output: typeof SavePartnerSplitSupplyNoticeValuesResponseSchema;
  },
  /**
   * DeletePartnerSplitSupplyNotice deletes a registration with its supply points
   * and values. The same condition can be registered again afterwards. Rejected with PARTNER_NOTICE_NOT_FOUND when no
   * registration of the organization has the id, NOTICE_DATE_CLOSED when the
   * registration is past (a 翌日 one delivered today or earlier, a 月間 one of this
   * month or earlier) and holds a saved value (an empty one can be deleted whatever
   * its date is), and Aborted when the registration moved since it was read.
   * Either way nothing is deleted.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.DeletePartnerSplitSupplyNotice
   */
  deletePartnerSplitSupplyNotice: {
    methodKind: "unary";
    input: typeof DeletePartnerSplitSupplyNoticeRequestSchema;
    output: typeof DeletePartnerSplitSupplyNoticeResponseSchema;
  },
  /**
   * IssuePartnerSplitSupplyNoticeUploadUrl prepares the import of the 他社の通告値
   * of one file (XML, ZIP or CSV): it returns a one-time upload token and a
   * presigned PUT request the browser sends the file to. The file itself never
   * travels in a request body. A token is good for one import (a preview does
   * not use it up) until it expires.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.IssuePartnerSplitSupplyNoticeUploadUrl
   */
  issuePartnerSplitSupplyNoticeUploadUrl: {
    methodKind: "unary";
    input: typeof IssuePartnerSplitSupplyNoticeUploadUrlRequestSchema;
    output: typeof IssuePartnerSplitSupplyNoticeUploadUrlResponseSchema;
  },
  /**
   * PreviewPartnerSplitSupplyNoticeImport reads the uploaded files and returns
   * what ImportPartnerSplitSupplyNotices would register, without writing
   * anything: the 通 (new or replacing), the supply points left out, the errors
   * of the files, and a digest of the whole plan. Errors in the files, nothing to
   * import and files over a limit are returned in the response (errors, nothing,
   * too_large), not as RPC errors. Rejected with PARTNER_NOTICE_IMPORT_UPLOAD_EXPIRED
   * when a token cannot be used.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.PreviewPartnerSplitSupplyNoticeImport
   */
  previewPartnerSplitSupplyNoticeImport: {
    methodKind: "unary";
    input: typeof PreviewPartnerSplitSupplyNoticeImportRequestSchema;
    output: typeof PreviewPartnerSplitSupplyNoticeImportResponseSchema;
  },
  /**
   * ImportPartnerSplitSupplyNotices registers the 通 of the uploaded files in one
   * transaction: a new registration where there is none; where one exists, only
   * the supply points the files carry are replaced (their 48 slots whole) and the
   * points the files do not carry stay as they are. The registration date,
   * registrant, channel and file names are kept; only the last update is the
   * import's. The plan is
   * computed again and must equal the digest the preview returned, or nothing is
   * imported (PARTNER_NOTICE_IMPORT_CHANGED). The upload tokens are used up.
   * Rejected with PARTNER_NOTICE_IMPORT_UPLOAD_EXPIRED, PARTNER_NOTICE_IMPORT_INVALID,
   * PARTNER_NOTICE_IMPORT_NOTHING, PARTNER_NOTICE_IMPORT_TOO_LARGE and
   * PARTNER_NOTICE_IMPORT_CHANGED; nothing is written then.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.ImportPartnerSplitSupplyNotices
   */
  importPartnerSplitSupplyNotices: {
    methodKind: "unary";
    input: typeof ImportPartnerSplitSupplyNoticesRequestSchema;
    output: typeof ImportPartnerSplitSupplyNoticesResponseSchema;
  },
  /**
   * IssueOwnSplitSupplyNoticeUploadUrl prepares the import of the 自社の通告値 of
   * one file (XML, ZIP or CSV), like IssuePartnerSplitSupplyNoticeUploadUrl. The
   * token is good for the own side's import only.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.IssueOwnSplitSupplyNoticeUploadUrl
   */
  issueOwnSplitSupplyNoticeUploadUrl: {
    methodKind: "unary";
    input: typeof IssueOwnSplitSupplyNoticeUploadUrlRequestSchema;
    output: typeof IssueOwnSplitSupplyNoticeUploadUrlResponseSchema;
  },
  /**
   * PreviewOwnSplitSupplyNoticeImport reads the uploaded files and returns what
   * ImportOwnSplitSupplyNotices would write, without writing anything: the 通
   * with the supply points created and overwritten, the supply points left out,
   * the supply points and (supply point, day) pairs with every slot empty that
   * are not imported, the errors of the files and a digest of the whole plan.
   * Errors in the files, nothing to import and files over a limit are returned
   * in the response (errors, nothing, too_large), not as RPC errors. Rejected
   * with OWN_NOTICE_IMPORT_UPLOAD_EXPIRED when a token cannot be used.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.PreviewOwnSplitSupplyNoticeImport
   */
  previewOwnSplitSupplyNoticeImport: {
    methodKind: "unary";
    input: typeof PreviewOwnSplitSupplyNoticeImportRequestSchema;
    output: typeof PreviewOwnSplitSupplyNoticeImportResponseSchema;
  },
  /**
   * ImportOwnSplitSupplyNotices writes the 自社の通告値 of the uploaded files in
   * one transaction: a supply point without one is created with every day of its
   * period (the values of the files only: a slot the files leave empty and a day
   * they do not carry stay empty, nothing is filled in from the 基本パターン),
   * one that has one gets the days the files carry overwritten and keeps the
   * other days. The plan is computed again and must equal the
   * digest the preview returned, or nothing is written
   * (OWN_NOTICE_IMPORT_CHANGED). The upload tokens are used up. Rejected with
   * OWN_NOTICE_IMPORT_UPLOAD_EXPIRED, _INVALID, _NOTHING, _TOO_LARGE and
   * _CHANGED; nothing is written then.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.ImportOwnSplitSupplyNotices
   */
  importOwnSplitSupplyNotices: {
    methodKind: "unary";
    input: typeof ImportOwnSplitSupplyNoticesRequestSchema;
    output: typeof ImportOwnSplitSupplyNoticesResponseSchema;
  },
  /**
   * DownloadOwnSplitSupplyNoticeCsvTemplate returns the CSV the import reads
   * (the same shape as the CSV for the other company), with a column for every
   * supply point whose 通告値 the own side submits. The cells hold the values the
   * 通告値 has now (a slot without a value stays empty) and, for a supply point
   * without one, the initial values a creation would give (the 基本パターン by
   * day type). Failed when a day type cannot be decided for such a supply point. Rejected with NOTICE_DATE_CLOSED when the period is past
   * and OWN_NOTICE_TEMPLATE_NO_POINTS when there is no supply point. When the
   * supply points are more than one file can carry (1000 columns, the most the
   * import reads in a file), the template is a ZIP of CSVs of at most 1000
   * columns each, which the import reads together.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.DownloadOwnSplitSupplyNoticeCsvTemplate
   */
  downloadOwnSplitSupplyNoticeCsvTemplate: {
    methodKind: "unary";
    input: typeof DownloadOwnSplitSupplyNoticeCsvTemplateRequestSchema;
    output: typeof DownloadOwnSplitSupplyNoticeCsvTemplateResponseSchema;
  },
  /**
   * GetSplitSupplyPlanAvailability returns whether the 分割供給計画 is released.
   * The decision is global (one flag shared by every organization). Every other
   * RPC of this service is rejected with FailedPrecondition while it is false.
   *
   * @generated from rpc bffuser.v1.SplitSupplyPlanService.GetSplitSupplyPlanAvailability
   */
  getSplitSupplyPlanAvailability: {
    methodKind: "unary";
    input: typeof GetSplitSupplyPlanAvailabilityRequestSchema;
    output: typeof GetSplitSupplyPlanAvailabilityResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_split_supply_plan_service, 0);

